import { render, staticRenderFns } from "./MultiBetSlipList.vue?vue&type=template&id=4d4a2cfe&scoped=true"
import script from "./MultiBetSlipList.vue?vue&type=script&lang=js"
export * from "./MultiBetSlipList.vue?vue&type=script&lang=js"
import style0 from "./MultiBetSlipList.vue?vue&type=style&index=0&id=4d4a2cfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4a2cfe",
  null
  
)

export default component.exports